<ng-container [formGroup]="editForm">
  <div class="row code-container" formGroupName="config">
    <ngx-monaco-editor class="w-100 h-100" [options]="codeEditorOptions$ | async" formControlName="code">
    </ngx-monaco-editor>
  </div>
</ng-container>
